// Vendored (trimmed) from the host app (conek-rails
// `app/frontend/shared/lib/notifications/notification-helpers.ts`) so the gem
// has no `shared/*` host-alias coupling. The gem's ui--notifications controller uses
// only `formatTimestamp`, so only that function is ported.
//
// Two deliberate divergences from the host original, both forced by the gem's
// zero-host-dependency constraint:
//   * locale comes from `<html lang>` (the same server-set signal the host
//     i18n instance bootstraps from) instead of the i18next instance;
//   * the absolute-date fallback uses `Intl.DateTimeFormat` instead of the
//     `@a-safe-digital/format-date` package. Relative-time output (the common
//     case — "now", "5m", "3h", "2d") is byte-identical: same
//     Intl.RelativeTimeFormat options (numeric: "auto", style: "narrow").

// Bound to the active app language (not the browser default) so relative
// timestamps follow the in-app language switch. `Intl.RelativeTimeFormat`
// caches internally, so rebuilding per call is cheap.
function relativeTimeFormat() {
  const language =
    (typeof document !== "undefined" && document.documentElement.lang) ||
    (typeof navigator !== "undefined" && navigator.language) ||
    "en-GB"
  return new Intl.RelativeTimeFormat(language, {
    numeric: "auto",
    style: "narrow",
  })
}

function formatDateFallback(date) {
  const language =
    (typeof document !== "undefined" && document.documentElement.lang) ||
    (typeof navigator !== "undefined" && navigator.language) ||
    "en-GB"
  return new Intl.DateTimeFormat(language, {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(date)
}

export function formatTimestamp(iso) {
  const date = new Date(iso)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const rtf = relativeTimeFormat()

  if (diffMins < 1) return rtf.format(0, "second")
  if (diffMins < 60) return rtf.format(-diffMins, "minute")
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return rtf.format(-diffHours, "hour")
  const diffDays = Math.floor(diffHours / 24)
  if (diffDays < 7) return rtf.format(-diffDays, "day")
  return formatDateFallback(date)
}
